import { IDrillGroupWell } from '../../interfaces/idrill-group-well';
import { DrillGroup } from '../drill-group';
import { Well } from '../well';

export class DrillGroupWellBase {
  DrillGroupWellId: number;
  DrillGroupId: number;
  WellId: number;
  SortOrder: number;
  SysStartTime: Date;
  SysEndTime: Date;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  DrillGroup?: DrillGroup;
  Well?: Well;

  constructor(item?: IDrillGroupWell) {
    if (item) {

      this.DrillGroupWellId = item.DrillGroupWellId;
      this.DrillGroupId = item.DrillGroupId;
      this.WellId = item.WellId;
      this.SortOrder = item.SortOrder;
      this.SysStartTime = item.SysStartTime ? new Date(item.SysStartTime) : null;
      this.SysEndTime = item.SysEndTime ? new Date(item.SysEndTime) : null;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.DrillGroup = new DrillGroup(item.DrillGroup);
      this.Well = new Well(item.Well);
    }
  }
}